import styles from './header.module.css';
import { ReactComponent as Logo } from '../../icons/logo.svg'
import star from '../../icons/profileStar.svg'
import icon from '../../icons/personIcon.svg'
import { useNavigate } from 'react-router-dom';
import ProfileDropdown from '../profileDropdown/dropdown.jsx';
import { useState, useRef, useEffect, memo, useContext } from 'react';
import Popup from '../popup/popup.jsx';
import Button from '../button/button.jsx';
import { UserDataContext } from '../../Context/Context.jsx';

const Header = () => {

  const { user, setUser } = useContext(UserDataContext);
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const menuRef = useRef();
  const infoMenuRef = useRef();
  const [showPopup, setShowPopup] = useState(false);
  const [isInfoMenuOpen, setIsInfoMenuOpen] = useState(false);
  const togglePopup = () => setShowPopup(!showPopup);

  const isLoggedIn = user.loggined;
  const infoMenuItems = [
    { label: 'About', onClick: () => navigate('/about') },
    { label: 'Privacy Policy', onClick: () => navigate('/privacy-policy') },
    { label: 'Terms & Conditions', onClick: () => navigate('/terms-and-conditions') },
    { label: 'Contact', onClick: () => navigate('/support') },
  ];

  const handleLogout = () => {
    setUser({ username: "", email: "", loggined: false })
    localStorage.removeItem("ATAccTok");
    localStorage.removeItem("ATRefTok");
    setOpen(false);
    setShowPopup(false);
    navigate("/");
  };

  const handleOpenLogoutPopup = () => {
    setOpen(false);
    setShowPopup(true);
  };
  
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }

      if (infoMenuRef.current && !infoMenuRef.current.contains(e.target)) {
        setIsInfoMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <header className={styles.header}>
        <Logo className={styles.logo} alt="Autie Travel Logo" onClick={() => navigate('/')} />
        <div className={styles.headerActions}>
          {isLoggedIn ? (
            <div className={styles.IconReview} ref={menuRef}>
              <div style={{ cursor: 'pointer' }} className={styles.Review} onClick={() => navigate('/myReviews')}>
                <img src={star} alt="star" className={styles.star} />
                <p className={styles.rate}>My reviews</p>
              </div>
              <img src={icon} alt="icon" className={styles.icon} onClick={() => setOpen(!open)} />
              {open && !showPopup && (
                <ProfileDropdown togglePopup={handleOpenLogoutPopup} setOpen={setOpen} />
              )}
            </div>
          ) : (
            <div className={styles.actionsDiv}>
              <Button onClick={() => navigate('/user?action=login')} children={'Log in'} buttonType={'whtBtn'} style={{ "width": "150px" }} id={styles.actionBtn1} />
              <Button onClick={() => navigate('/user?action=signup')} children={'Sign up'} style={{ "width": "150px", margin: "0", height: '47px' }} id={styles.actionBtn2} />
            </div>
          )}
          <div className={styles.infoMenuWrapper} ref={infoMenuRef}>
            <button
              type="button"
              className={styles.hamburgerButton}
              aria-label="Open navigation menu"
              aria-expanded={isInfoMenuOpen}
              onClick={() => setIsInfoMenuOpen((prev) => !prev)}
            >
              <span className={styles.hamburgerLine}></span>
              <span className={styles.hamburgerLine}></span>
              <span className={styles.hamburgerLine}></span>
            </button>
            <div className={`${styles.infoDropdown} ${isInfoMenuOpen ? styles.infoDropdownOpen : ''}`}>
              <button
                type="button"
                className={styles.infoMenuClose}
                aria-label="Close navigation menu"
                onClick={() => setIsInfoMenuOpen(false)}
              >
                &#x2715;
              </button>
              {infoMenuItems.map((item) => (
                <button
                  key={item.label}
                  type="button"
                  className={styles.infoDropdownItem}
                  onClick={() => {
                    if (item.onClick) {
                      item.onClick();
                    }
                    setIsInfoMenuOpen(false);
                  }}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        </div>
        {showPopup && (
          <Popup hideLogo={true} visible={showPopup} style={{ maxWidth: "436px", alignItems: "baseline", gap: "10px", padding: "20px", borderRadius: "24px" }} >
            <div style={{ width: "100%", textAlign: "right", cursor: "pointer" }}>
              <span onClick={() => setShowPopup(false)} className={styles.close}>&#x2715;</span>
            </div>
            <div className={styles.lgoutText}>
              <p style={{ fontSize: "22px", fontWeight: "600", fontFamily: "Montserrat, sans-serif" }}> Log Out?</p>
              <p style={{ fontSize: "16px", fontFamily: "Montserrat, sans-serif", fontWeight: "500", marginTop: "17px" }}>Are you sure want to log out?</p>
              <div className={styles.btnsDiv}>
                <Button id={styles.cnclBtn} style={{ backgroundColor: '#BEBEBE' }} onClick={togglePopup} children={`Cancel`} />
                <Button id={styles.lgoutBtn} onClick={handleLogout} children={`Log out`} />
              </div>
            </div>
          </Popup>
        )}
      </header>
    </>
  );
};

export default memo(Header);
